var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-list-item",on:{"click":_vm.onSelectVideo}},[_c('img',{attrs:{"src":_vm.thumbUrl,"alt":""}}),_c('h3',[_vm._v(_vm._s(_vm._f("unescape")(_vm.videoTitle)))]),_c('p',[_vm._v(_vm._s(_vm.videoDesc))])])}
var staticRenderFns = []

export { render, staticRenderFns }